module.exports = __webpack_public_path__ + "static/media/03_Ministeredesaffairesetrangeres.b0e51a74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_affaires-etrangeres/03_Ministeredesaffairesetrangeres.jpg
// module id = 1176
// module chunks = 37